const data = Object.freeze({
  _30Minutos: 2,
  _35Minutos: 13,
  _40Minutos: 14,
  _45Minutos: 4,
  _50Minutos: 6,
  _55Minutos: 16,
  _60Minutos: 5,
  _90Minutos: 7,
  _120Minutos: 8,
  _150Minutos: 23,
  _180Minutos: 21,
  _MasDe180Minutos: 24,
});
export default data;
